import firebase from "config/firebase";
import { toast } from "react-toastify";
export const addRvRatingData =
  (officialData, onComplete = () => {}) =>
  async (dispatch) => {
    let { officialIdDocument, ...data } = officialData;
    try {
      const storage = firebase.storage();
      const storageRef = storage.ref(
        `officialIdDocuments/${officialIdDocument.name}`
      );
      const snapshot = await storageRef.put(officialIdDocument);
      const downloadURL = await snapshot.ref.getDownloadURL();
      let newData = {
        ...data,
        officialIdDocument: downloadURL,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      };

      await firebase
        .firestore()
        .collection("rv-rating")
        .add(newData)
        .then(async () => {
          toast.success("Add rating successfully");
          onComplete();
        });
    } catch (error) {
      toast.error("Error adding rating: " + error.message);
    }
  };

export const getAthleteData = (id, data, index) => (dispatch) => {
  firebase
    .firestore()
    .collection("users")
    .where("athleteID", "==", Number(id))
    .where("state", "==", data.state)
    .where("sportLevel", "==", data.contractLevel)
    .where("city", "==", data.college)
    .where("institute_name", "==", data.newSchool)
    .get()
    .then((querySnapshot) => {
      const userData = [];
      querySnapshot.forEach((doc) => {
        userData.push({ id: doc.id, ...doc.data() });
      });
      if (!querySnapshot.empty) {
        dispatch({
          type: "GET_ATHLETE_DATA",
          payload: { data: userData[0], index: index },
        });
      } else {
        toast.warning("Athlete not found");
        dispatch(deleteAthleteWithIndex(index));
      }
    });
};

export const deleteAthleteWithIndex = (index) => (dispatch) => {
  dispatch({
    type: "DELETE_ATHLETE_WITH_INDEX",
    payload: index,
  });
};

export const clearAthleteData = () => (dispatch) => {
  dispatch({
    type: "CLEAR_ATHLETE_WITH_INDEX",
    payload: [],
  });
};

export const isShowRvRating =
  (data, onComplete = () => {}) =>
  async () => {
    await firebase.firestore().collection("users").doc(data.id).update({
      isShowRvRating: data.isShowRvRating,
    });
    onComplete();
  };
